export const KEYS = {
  NEW: 'NEW',
  OPEN: 'OPEN',
  CALL: 'CALL',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE',
};

export const TICKET_STATUS = KEYS;

export const TICKET_STATUSES = {
  ...KEYS,
};

export const TICKET_STATUS_SIMPLE = {
  NEW: 'NEW',
  OPEN: 'OPEN',
  COMPLETE: 'COMPLETE',
};

const convertToOption = (item) => ({
  label: `TICKET_STATUS.${item}`,
  value: item,
});

export const TICKET_LIST = Object.keys(KEYS);

export const TICKET_LIST_SIMPLE = Object.keys(TICKET_STATUS_SIMPLE);

export const TICKET_STATUS_OPTIONS = TICKET_LIST.map(convertToOption);
export const TICKET_STATUS_SIMPLE_OPTIONS = TICKET_LIST_SIMPLE.map(convertToOption);
